import Breadcrumbs from "./breadcrumbs";

export default function TitleBanner({
  title,
  text = null,
  date = null,
  location = null,
  hours_per_week = null,
  bgColor = "gray",
  cssClasses = "",
}) {
  return (
    <section
      className={`title-banner ${
        bgColor === "green" ? "title-banner--bg-green" : ""
      } ${cssClasses}`}
    >
      <div className="container pt-40 pb-40 pt-md-50 pb-md-75">
        <div className="frame frame--justify-sm-center">
          <div className="bit-xxs-12 bit-sm-11 bit-md-10 bit-lg-8">
            <div className="pb-20">
              <Breadcrumbs html="" />
            </div>
            {title && (
              <h1
                className="text--white h2 pb-20"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {text && (
              <div
                className="text--weight-normal"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
            {date && (
              <div className="text--uppercase">
                <small>
                  <strong>
                    <i className="fas fa-clock mr-5" /> {date}
                  </strong>
                </small>
              </div>
            )}
            {location && (
              <div className="text--uppercase">
                <small>
                  <strong>
                    <i className="fas fa-map-marker-alt" /> {location}
                  </strong>
                </small>
              </div>
            )}
            {hours_per_week && (
              <div className="text--uppercase">
                <small>
                  <strong>
                    <i className="fas fa-clock mr-5" /> {hours_per_week}
                  </strong>
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
